import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import { useI18n } from "@/context/I18nContext";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (form.password !== form.confirm) { setErr(t("auth.mismatch")); return; }
    setLoading(true);
    try { const { data } = await api.post("/auth/reset-password", { token, password: form.password }); toast.success(data.message); nav("/login"); }
    catch (e2) { const m = apiError(e2); setErr(m); toast.error(m); }
    setLoading(false);
  };

  if (!token) return <AuthShell title="Invalid link"><p className="text-slate-400">This reset link is invalid. <Link to="/forgot-password" className="text-amber-400">Request a new one</Link>.</p></AuthShell>;

  return (
    <AuthShell title={t("auth.resetTitle")} footer={<Link to="/login" className="text-amber-400 font-semibold">{t("auth.signin")}</Link>}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        {err && <div className="rounded-lg bg-red-500/10 border border-red-500/30 text-red-300 text-sm px-4 py-3">{err}</div>}
        <div><label className="label-lux">{t("auth.password")}</label><input required type="password" className="input-lux mt-2" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reset-password-input" /></div>
        <div><label className="label-lux">{t("auth.confirm")}</label><input required type="password" className="input-lux mt-2" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="reset-confirm-input" /></div>
        <button disabled={loading} className="gold-btn w-full" data-testid="reset-submit-btn">{loading ? <Loader2 className="animate-spin" size={18} /> : t("auth.sendReset")}</button>
      </form>
    </AuthShell>
  );
}
